export default __webpack_public_path__ + "static/media/Feik_DDC27FC77F518.2f353581.jpg";